<div formHolder [style.max-height.px]="formHeight" style="padding: 20px" class="limit-height">
    @if(fullRequest?.id) {
        <div class="main">
            <div class="item" style="max-width:330px;">
                <ng-container [ngTemplateOutlet]="mainSrDiv"></ng-container>
                <ng-container [ngTemplateOutlet]="addPersonTemplate"></ng-container>
                <ng-container [ngTemplateOutlet]="reopenTemplate"></ng-container>
                @if (!isPhone) {
                    <div style="margin-top:20px">
                        <ng-container [ngTemplateOutlet]="listRequests"></ng-container>
                    </div>
                }
            </div>
            <ng-container [ngTemplateOutlet]="chatControl"></ng-container>
            @if (isPhone) {
                <div style="margin-top:10px; margin-bottom: 20px; width: 330px; margin-left:auto; margin-right:auto">
                    <ng-container [ngTemplateOutlet]="listRequests"></ng-container>
                </div>
            }
        </div>
    }
</div>

<ng-template #mainSrDiv>
    <mat-card style="padding:20px; margin-bottom:20px">
        <h1>Service Request Details</h1>
        <div style="width:100%; display:flex">
            <div style="flex:1; padding-right: 3px">
                <p class="label">Reference</p>
                <p>{{fullRequest?.refNr}}</p>
                <p class="label">Status</p>
                <p><span [ngClass]="$any(fullRequest?.srStatus)">{{requestStatus()}}</span></p>
                @if(fullRequest?.srCloseStatus) {
                    <p class="label">Substatus</p>
                    <p><span>{{requestSubStatus()}}</span></p>
                }
            </div>
            <div style="flex:1; padding-left: 3px">
                <p class="label">Created</p>
                <p>{{fullRequest?.createdAt | fromNow}}</p>
                <p class="label">Last Updated</p>
                <p>
                    @if (fullRequest?.updatedAt) {
                        {{fullRequest?.updatedAt | fromNow}}
                    } @else {
                        n/a
                    }
                </p>
                <p class="label">Source</p>
                <p>{{requestSource()}}</p>
            </div>
        </div>
        <p class="label">Topic</p>
        <p>{{requestTopic()}}</p>
        <p class="label">Class</p>
        <p>{{requestClass()}}</p>
        <p class="label">Unit</p>
        <p>@if (fullRequest.unit) {
                {{fullRequest.unit.address}} ({{fullRequest.unit.name}})
            } @else { n/a }
        </p>
        <p class="label">Title</p>
        <p>{{fullRequest?.title}}</p>
        <p class="label">Description</p>
        <p [innerHTML]="descriptionText"></p>

        <p class="label">Attachments</p>
        @if (fullRequest?.attachments?.length > 0) {
            <ul style="margin-top: 5px; margin-bottom:-5px">
                @for (a of fullRequest.attachments; track $index) {
                <li>
                    <a [href]="'/api/api/' + fullRequest.teamId+ '/crm/requests/attach/' + a.id">{{a.name}}</a>
                </li>
                }
            </ul>
        }
        <app-ctl-holder [control]="attachmentGrid.control"></app-ctl-holder>
    </mat-card>
</ng-template>

<ng-template #chatControl>
    <div class="item">
        <div class="chatDiv">
            <div style="overflow: auto;" class="limit-height">
                <app-ctl-holder [control]="chatField.control"></app-ctl-holder>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #reopenTemplate>
    @if (fullRequest?.srStatus === 'resolved') {
    <mat-card class="action">
        <div class="action">
            <p>This request may be automatically be accepted if not reopened before {{getCloseDate(fullRequest.completedAt)}}</p>
            <div>
            <button mat-raised-button color="accent" (click)="reopenRequest()">Reopen</button>
            <button mat-raised-button color="primary" style="margin-top: 5px"
            (click)="acceptRequest()">Accept</button>
            </div>

        </div>
    </mat-card>
    }
</ng-template>

<ng-template #addPersonTemplate>
    @if (isUnitOwnerRequest && fullRequest.srStatus === 'open') {
        <mat-card class="action" data-unit-access-request>
            <div class="action">
                <p>Add {{$any(fullRequest.data)['person']['firstName']}}
                    {{$any(fullRequest.data)['person']['lastName']}} to Unit?</p>
                <button mat-raised-button color="primary" data-unit-access="approve" (click)="addToUnit()">Yes</button>
                <button mat-raised-button color="warn" data-unit-access="decline" (click)="declineAddToUnit()">No</button>
            </div>
        </mat-card>
    }
</ng-template>
<ng-template #listRequests>
    <mat-card style="margin-top: 10px; padding: 20px">
        <h3>Your Other Open Requests</h3>
        @if (openRequests.length > 1) {
            <ul style="margin-top: -10px">
                @for (r of openRequests; track $index) {
                    @if (r.id !== fullRequest.id) {
                        <li>
                            <a [routerLink]="'/' + r.teamId + '/myRequests/' + r.id">{{r.refNr}}</a> {{r.title}}
                        </li>
                    }
                }
            </ul>
        } @else {
            <p style="padding-left: 20px">This your only open request</p>
        }
    </mat-card>
</ng-template>
